import { useSelector } from "react-redux";
import { isArray } from "lodash";
import { ApiErrorCodes } from "@financeable/lenders/models/components";
import { Stack, Typography } from "@financeable-com-au/financeable-ui";
// @ts-expect-error: ignoring as it is existing js file
import { applicationSelector } from "@/store/slices/applicationFormSlice";
import type { ApplicationFormSlice, ApplicationState } from "@/store/slices/types/applicationFormSlice";
import type { LenderErrorV1 } from "@/store/slices/types/lenders";
import { useApplicationRouteType } from "@/components/SubmissionModal/hooks/useApplicationRouteType";

const ErrorMessageV1 = () => {
  const { submissionModal } = useSelector<ApplicationFormSlice, ApplicationState>(applicationSelector);
  const applicationRouteType = useApplicationRouteType();
  const { error, message } = submissionModal.submission;
  const { errorCode, errorMessage } = (error as LenderErrorV1["error"]) ?? {};

  if (errorCode === ApiErrorCodes.ValidationError) {
    return (
      <Stack>
        <Typography>Unfortunately, your {applicationRouteType} was not uploaded.</Typography>
        <Typography mb={3}>The following fields are invalid:</Typography>
        {isArray(errorMessage) ? (
          errorMessage.map((item, index) => {
            return (
              <Typography level="body-xs" key={index}>
                <code>{item}</code>
              </Typography>
            );
          })
        ) : (
          <Typography level="body-xs">
            <code>{errorMessage}</code>
          </Typography>
        )}
      </Stack>
    );
  }
  return (
    <>
      <Typography>There was an error with your {applicationRouteType} lodgement.</Typography>
      <Typography level="body-xs">
        <code>{errorMessage ?? message}</code>
      </Typography>
    </>
  );
};

export { ErrorMessageV1 };
